export default {
  buttons: {
    next: "Avanti",
    prev: "Indietro",
    skip: "Salta",
    done: "Fine",
    gotIt: "Capito",
  },
  messages: {
    dontShowAgainLabel: "Non mostrare più",
    stepNumbersOfLabel: "di",
  },
};
